import mime from 'mime-types'
import { downloadUrl } from '@/helpers/download'

type ShareData = {
  title?: string
  text?: string
  url?: string
  files?: File[]
}

interface Navigator {
  share?: (data?: ShareData) => Promise<void>
  canShare?: (data?: ShareData) => boolean
}

const navigator = window.navigator as Navigator

export const canShareFiles = (): boolean => !!navigator.canShare

export const canShare = (): boolean => !!navigator.share

const appendFileExtIfNeeded = (filename: string, ext: string | false) => {
  const filenameArr = filename.split('.')
  if (filenameArr.length > 1) return filename // already has extension
  if (ext === false) throw Error('file extension not found')

  return [...filenameArr, ext].join('.')
}

export const shareUrl = (url: string, opts = {} as ShareData) => {
  return new Promise<void>((resolve, reject) => {
    if (navigator.share) {
      opts.url = url
      navigator
        .share(opts)
        .then(() => resolve())
        .catch((err) => reject(err))
    } else {
      reject('your browser does not support sharing urls')
    }
  })
}

export const shareFileFromUrl = (url: string, filename?: string) => {
  return new Promise<void>((resolve, reject) => {
    downloadUrl(url)
      .then((blob: Blob) => {
        const fileType = blob.type
        filename = appendFileExtIfNeeded(
          filename || 'download',
          mime.extension(fileType)
        )

        const file = new File([blob], filename, { type: fileType })
        const filesArray = [file]

        if (
          navigator.share &&
          navigator.canShare &&
          navigator.canShare({ files: filesArray })
        ) {
          navigator
            .share({
              files: filesArray,
            })
            .then(() => resolve())
            .catch((err) => reject(err))
        } else {
          reject('your browser does not support sharing files')
        }
      })
      .catch((err) => reject(err))
  })
}
